/** Public names are snake_case. Only documented legacy names are aliases. */
export const WIDGET_PARAM_ALIASES = {
  calendar_date: ["calendarDate"],
  calendar_timeslot: ["calendarTimeslot"],
  calendar_special_event: ["calendarSpecialEvent"],
  calendar_open_state: ["calendarOpenState"],
  display_price_patron_type_id: ["displayPricePatronTypeId"],
  hide_price: ["hidePrice"],
  highlight_multi_day_events_on_start_date_only: [
    "highlightMultiDayEventsOnStartDateOnly",
  ],
  is_widget: ["isWidget"],
  is_embedded: ["isEmbedded"],
  jump_to_event: ["jump-to-event"],
  keep_shopping: ["keep-shopping"],
  prompt_for_quantity: ["prompt-for-quantity"],
  redirect_url: ["redirect-url"],
  show_specific_tickets: ["show-specific-tickets"],
  show_description: ["show-description"],
  theme_dark: ["theme-dark"],
  theme_primary: ["theme-primary"],
  theme_secondary: ["theme-secondary"],
  ticket_type_selection_required: [
    "ticket-type-selection-required",
    "ticket-type-selection-requried",
  ],
  tracking_id: ["tracking-id"],
  branding_style: ["branding-style"],
} as const;

export type WidgetParamAliases<T> = {
  [Key in keyof typeof WIDGET_PARAM_ALIASES as (typeof WIDGET_PARAM_ALIASES)[Key][number]]?: Key extends keyof T
    ? T[Key]
    : never;
};

/**
 * Normalize SDK objects and parsed URL queries without mutating the caller.
 * An explicitly supplied canonical value wins, including false, zero and "".
 * Undefined canonical values fall back to the legacy alias. Unknown keys and
 * values are preserved; validation remains with the owning feature.
 */
export function normalizeWidgetParams<T extends object>(params: T): T {
  const normalized: Record<string, unknown> = Object.fromEntries(
    Object.entries(params)
  );
  Object.entries(WIDGET_PARAM_ALIASES).forEach(([canonical, aliases]) => {
    aliases.forEach((alias) => {
      if (
        normalized[canonical] === undefined &&
        normalized[alias] !== undefined
      ) {
        normalized[canonical] = normalized[alias];
      }
      delete normalized[alias];
    });
  });
  return normalized as T;
}
